<div class="layout-topbar">
    <div class="layout-topbar-start">
        <a class="layout-topbar-logo" routerLink="/">
            <svg width="61" height="42" viewBox="0 0 61 42" fill="none" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <rect width="54" height="49" fill="url(#pattern0_1_2)" />
                <defs>
                    <pattern id="pattern0_1_2" patternContentUnits="objectBoundingBox" width="1" height="1">
                        <use xlink:href="#image0_1_2" transform="scale(0.0185185 0.0204082)" />
                    </pattern>
                    <image id="image0_1_2" width="61" height="42"
                        xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAxCAYAAACRQFplAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJWSURBVHgB7dlPTttAFMfx3zOwqNRFpLZ7H4FK7QFyguYG7bbqokcgvUE3VcWq5QbhBFHXRYIb4D0sskBCJMGDX4axyT/smXnMGIuvhESy8JuPkmj8B2hBvcFpWvz1IFiCyDFqh/LxLqmxJI4QMYMqFpHqd+hsrqg/Gb2fwLNosHWUSQYXBbYdZfLHBYfVo0x+uKCw5iiTOy4YzB5lcsMFgbmjTPY40X1M/UnX9iF/1OLI+7b7nBhsdpgeTKc4v/qV7pv3eCH+KJMdTgTGqFxhCIXe3i7GBsdfHVL5EcRqjvP+jZWo5aNOZnP0X3/Lzvjl28H/ISg5gFj1vzkv2EZUdeSoOGfYo6jq6NFwTrBGqGpCFJw1zApVTQmOs4I5oapJQXGNYV6ocnY4XCOYCKqcvYx7Mzj5SUTfIZbG1W7QoihOYbKTYPF14dMtEH2CZOr2uPYTE0cBWXG8/quvWSZzDrmSyn9cjj4O+d+tsOeM4jbCnjuKW4N1AcUtwbqC4kpYl1DcAtY1FEddRHHJzRzHvGlCKkLvNsfiCrfYKLNEqX+QqiFKL6OIL+X3Eox5UZBo5bTp3eDkryL6DJ8sUHoJ97UaZ4nS4x/USpwDSo9eqVU4R5Qeu6FW4DxQeuSWouI8UXrcI0XBCaD0qJqC4oRQXO0VNC9glqMvtok/uILmLkYfvpBSR5IorvHNHKFPrjzdwhNndfvNExcMxVnfMHXEBUVxTre4LXHBUZzzQ4mGuCgozusxUg0uGorzfvC3BRcVxXnDuBVcdJRojJsepqfXv9MULz1dd4MghxRxnCt6AAAAAElFTkSuQmCC" />
                </defs>
            </svg>
            <svg width="150" height="60" viewBox="0 0 150 60" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="layout-topbar-logo-full">
                <text x="5" y="40" font-family="Arial" font-size="24"
                    fill="var(--topbar-item-text-color)">{{translation_service.getText('lbl_worksheet')}}</text>
            </svg>
        </a>
        <a #menuButton class="layout-menu-button" (click)="onMenuButtonClick()" pRipple>
            <i class="pi pi-chevron-right"></i>
        </a>

        <a #mobileMenuButton class="layout-topbar-mobile-button" (click)="onMobileTopbarMenuButtonClick()" pRipple>
            <i class="pi pi-ellipsis-v"></i>
        </a>
    </div>

    <div class="layout-topbar-end">
        <div class="layout-topbar-actions-start">
            <p-megaMenu [hidden]="true" [model]="model" styleClass="layout-megamenu"></p-megaMenu>
        </div>
        <div class="layout-topbar-actions-end">
            <ul class="layout-topbar-items">
                <li>
                    <a pStyleClass="@next" enterFromClass="ng-hidden" enterActiveClass="px-scalein"
                        (click)="overlayPanel.toggle($event)" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout"
                        [hideOnOutsideClick]="true" pRipple>
                        <img src="{{imageSrc}}" alt="avatar" class="w-2rem h-2rem">
                    </a>
                    <p-overlayPanel #overlayPanel>
                        <div>
                            <ul class="list-none p-0 m-0 flex flex-column gap-1">
                                <li *ngFor="let language of languages"
                                    class="list-none p-0 m-0 flex align-items-center gap-2 cursor-pointer"
                                    title="{{language.title}}">
                                    <a class="cursor-pointer flex align-items-center py-2 hover:surface-hover transition-duration-150 transition-all px-3 py-2"
                                        (click)="changeLanguage(language.value)">
                                        <i class="mr-2 mt-1"><img [src]="language.image"></i>
                                        <span>{{ language.title }}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </p-overlayPanel>
                </li>
                <li>

                    <a (click)="onRightMenuButtonClick()">
                        <i class="pi pi-bell" *ngIf="notification_count > 0" pBadge [value]="notification_count"
                            severity="warning">
                        </i>
                        <i class="pi pi-bell" *ngIf="notification_count === 0"></i>
                    </a>
                </li>
                <li style="display: none;">
                    <a pStyleClass="@next" enterFromClass="ng-hidden" enterActiveClass="px-scalein"
                        leaveToClass="ng-hidden" leaveActiveClass="px-fadeout" [hideOnOutsideClick]="true" pRipple>
                        <i class="pi pi-table"></i>
                    </a>

                    <div class="ng-hidden">
                        <div class="flex flex-wrap">
                            <div class="w-4 flex flex-column align-items-center p-3">
                                <button pButton class="p-button-rounded mb-2" icon="pi pi-image" pRipple></button>
                                <span>{{translation_service.getText('lbl_products')}}</span>
                            </div>
                            <div class="w-4 flex flex-column align-items-center p-3">
                                <button pButton class="p-button-rounded mb-2 p-button-success" icon="pi pi-file-pdf"
                                    pRipple></button>
                                <span>{{translation_service.getText('lbl_reports')}}</span>
                            </div>
                            <div class="w-4 flex flex-column align-items-center p-3">
                                <button pButton class="p-button-rounded mb-2 p-button-secondary" icon="pi pi-dollar"
                                    pRipple></button>
                                <span>Balance</span>
                            </div>
                            <div class="w-4 flex flex-column align-items-center p-3">
                                <button pButton class="p-button-rounded mb-2 p-button-warning" icon="pi pi-cog"
                                    pRipple></button>
                                <span>{{translation_service.getText('lbl_settings')}}</span>
                            </div>
                            <div class="w-4 flex flex-column align-items-center p-3">
                                <button pButton class="p-button-rounded mb-2 p-button-help" icon="pi pi-key"
                                    pRipple></button>
                                <span>Credentials</span>
                            </div>
                            <div class="w-4 flex flex-column align-items-center p-3">
                                <button pButton class="p-button-rounded mb-2 p-button-info" icon="pi pi-sitemap"
                                    pRipple></button>
                                <span>Sitemap</span>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <a pStyleClass="@next" enterFromClass="ng-hidden" enterActiveClass="px-scalein"
                        (click)="profile.toggle($event)" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout"
                        [hideOnOutsideClick]="true" pRipple>
                        <img id="userProfile" [src]="userProfileImage ? userProfileImage : getDefault()" alt="avatar"
                            class="w-2rem h-2rem userImg">
                    </a>
                    <p-overlayPanel #profile>
                        <div class="">
                            <ul class="list-none p-0 m-0 ">
                                <li class="gap-2">
                                    <a
                                        class="cursor-pointer block py-2 hover:surface-hover transition-duration-150 transition-all px-3 py-2">
                                        <div>
                                            <span class="font-medium text-900 text-xl"
                                                [pTooltip]="displayName && displayName.length > 10 ? displayName : undefined">
                                                Hello! {{ displayName && displayName.length > 10 ? (displayName |
                                                slice:0:10) + '...' : displayName }}
                                            </span>
                                        </div>

                                        <div class="mt-1">
                                            <span
                                                [pTooltip]="shared_service.org_name && shared_service.org_name.length > 5 ? shared_service.org_name : undefined">
                                                {{translation_service.getText('lbl_organization')}} - {{
                                                shared_service.org_name && shared_service.org_name.length > 15 ?
                                                (shared_service.org_name |
                                                slice:0:15) + '...' : shared_service.org_name }}</span>
                                        </div>
                                    </a>
                                </li>
                                <li class="gap-2">
                                    <a (click)="switchOrganization()"
                                        class="cursor-pointer flex align-items-center py-2 hover:surface-hover transition-duration-150 transition-all px-3 py-2"
                                        pRipple>
                                        <i class="pi pi-arrow-right-arrow-left mr-2"></i>
                                        <span>{{translation_service.getText('lbl_switch_organization')}} </span>
                                    </a>
                                </li>
                                <li class="gap-2">
                                    <a (click)="toggleProfilesetting()"
                                        class="cursor-pointer flex align-items-center py-2 hover:surface-hover transition-duration-150 transition-all px-3 py-2"
                                        pRipple>
                                        <i class="pi pi-cog mr-2"></i>
                                        <span>{{translation_service.getText('lbl_profile_settings')}}</span>
                                    </a>
                                </li>
                                <li class="gap-2">
                                    <a (click)="signOut()"
                                        class="cursor-pointer flex align-items-center py-2 hover:surface-hover transition-duration-150 transition-all px-3 py-2"
                                        pRipple>
                                        <i class="pi pi-sign-out mr-2"></i>
                                        <span>{{translation_service.getText('lbl_logout')}}</span>
                                    </a>
                                </li>
                                <li class="gap-2">
                                    <a (click)="signOutAllDevice()"
                                        class="cursor-pointer flex align-items-center py-2 hover:surface-hover transition-duration-150 transition-all px-3 py-2"
                                        pRipple>
                                        <i class="pi pi-power-off mr-2"></i>
                                        <span>{{translation_service.getText('lbl_logout_frm_all_devices')}}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </p-overlayPanel>
                </li>

                <li style="display: none;">
                    <a (click)="onRightMenuButtonClick()" pRipple>
                        <i class="pi pi-arrow-left"></i>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>